import { Link } from "react-router-dom"

import {IoIosArrowBack} from 'react-icons/io'

const ProjectButtons = () =>
{
    return(
        <div className="project-buttons">
            <Link to="/" className="project-prev-btn"><IoIosArrowBack className="project-buttons-icon" /> Home</Link>
            <Link to="/projects" className="project-prev-btn">All projects</Link>
            {/* <Link className="project-next-btn">Next <IoIosArrowForward className="project-buttons-icon" /></Link> */}
        </div>
    )
}

export default ProjectButtons